// extracted by mini-css-extract-plugin
export default {"container":"Icon_container__BLv0n"};